import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/user-activation/")({
    beforeLoad: () => {
        throw redirect({ to: "/customers/success", replace: true });
    },
});
